import Decimal from "decimal.js";

import type { ColDef, FormulaFuncs } from "ag-grid-enterprise";
import { themeBalham } from "ag-grid-enterprise";

import { formatNumber } from "../../Helpers/formatNumber";

export const theme = themeBalham.withParams({
  borderColor: "transparent",
  oddRowBackgroundColor: "transparent",
  spacing: 1,
});

export const defaultColDef: ColDef = {
  sortable: false,
  resizable: false,
  suppressMovable: true,
  suppressHeaderMenuButton: true,
  autoHeaderHeight: true,
};

export const formulaFuncs = (params: {
  withoutCents: boolean;
}): FormulaFuncs => ({
  SUM: {
    func: ({ values }) => {
      const numbers = Array.from(values) as number[];
      return numbers.reduce(
        (sum, value) =>
          new Decimal(sum as number).add(value as number).toNumber(),
        0,
      );
    },
  },
  SUBTRACT: {
    func: ({ values }) => {
      const [first, ...rest] = Array.from(values) as number[];

      return rest
        .reduce((result, value) => result.sub(value), new Decimal(first))
        .toNumber();
    },
  },
  MULTIPLY: {
    func: ({ values }) => {
      const numbers = Array.from(values) as number[];
      return numbers
        .reduce((result, value) => result.mul(value as number), new Decimal(1))
        .toNumber();
    },
  },
  DIVIDE: {
    func: ({ values }) => {
      const [numerator, denominator] = Array.from(values) as number[];

      return denominator === 0
        ? 0
        : new Decimal(numerator).div(denominator).toNumber();
    },
  },
  PERCENTAGE: {
    func: ({ values }) => {
      const value = Array.from(values)[0];

      return new Decimal(value as number).mul(100).toNumber();
    },
  },
  DECIMAL: {
    func: ({ values }) => {
      const value = Array.from(values)[0];

      return new Decimal(value as number).div(100).toNumber();
    },
  },
  ROUND: {
    func: ({ values }) => {
      const value = Array.from(values)[0];

      return formatNumber(value as number, "number", params.withoutCents);
    },
  },
});
